import { bannerListQuery, HYDRATED_QUERY_OPTIONS } from '@/lib/page-queries';
import { useQuery } from '@tanstack/react-query';
import { getStoryBanner } from '../banner.service';
import { ApiResponse, QUERY_KEYS } from '../base-api';
import {
  BannerListResponse,
  GetBannerListParams,
  GetStoryBannerParams,
} from '../types/banner.type';

// export const useBannerList = (params?: GetBannerListParams) => {
//   return useQuery<ApiResponse<BannerEntity[]>>({
//     queryKey: [QUERY_KEYS.BANNER, QUERY_KEYS.LIST, params],
//     queryFn: () => getBannerList(params),
//   });
// };

export const useBannerList = (params?: GetBannerListParams) => {
  return useQuery<ApiResponse<BannerListResponse>>({
    ...bannerListQuery(params),
    ...HYDRATED_QUERY_OPTIONS,
  });
};

// 스토리 배너(게시글 상세 상단) 조회. articleId/boardType 이 준비된 경우에만 호출
export const useStoryBanner = (
  params?: GetStoryBannerParams,
  enabled = true,
) => {
  return useQuery<ApiResponse<BannerListResponse>>({
    queryKey: [QUERY_KEYS.BANNER, 'story', params],
    queryFn: () => getStoryBanner(params),
    enabled,
  });
};
